const PendoTooltipObserver = () => {
  return null;
};

export default PendoTooltipObserver;
